import { render } from "./PersonasDashboard.vue?vue&type=template&id=7f3b3256&scoped=true"
import script from "./PersonasDashboard.vue?vue&type=script&lang=js"
export * from "./PersonasDashboard.vue?vue&type=script&lang=js"

import "./PersonasDashboard.vue?vue&type=style&index=0&id=7f3b3256&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f3b3256"]])

export default __exports__